import React from 'react';

import { withFirebase } from '../components/Firebase';
import AuthUserContext from '../components/Session/context';



class AdminPage extends React.Component {
  static contextType = AuthUserContext;
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      users: [],
      currentUser: '',
    };
  }

  componentDidMount() {
    console.log(this.context)
    this.setState({ loading: true });
    this.props.firebase.user('EVYmTmyPmTbcpaSlUOBh494Sgbz2').once('value', snapshot => {
      console.log(snapshot.val())
    })

    this.props.firebase.users().on('value', snapshot => {
      const usersObject = snapshot.val();

      const userList = Object.keys(usersObject).map(key => ({
        ...usersObject[key],
        uid: key,
      }));
      
      
      this.setState({
        users: userList,
        loading: false,
      })
    })
  }

  componentWillUnmount() {
    this.props.firebase.users().off();
  }

  render() {
    return (
      <div>
              <span>{}</span>
            <h1>Admin</h1>
            <ul>
              {this.state.users.map(user => (
                <li key={user.uid}>
                  <span style={{ display: 'block' }}>ID: {user.uid}</span>
                  <span>Email: {user.email}</span>
                </li>
              ))}
            </ul>
          </div>

    );
  }
}



export default withFirebase(AdminPage);